import api from './api';
import { saveAs } from 'file-saver';
import { postWithChecklistCompletion } from '@/helpers/checklistCompletion';

const CommunicationUcaaS = process.env.VUE_APP_CommunicationUcaaS;

class UserService {
    getPublicContent() {
        return api.get('/test/all');
    }

    getUserBoard() {
        return api.get('/test/user');
    }

    getModeratorBoard() {
        return api.get('/test/mod');
    }

    getAdminBoard() {
        return api.get('/test/admin');
    }

    async LogIn(User) {
        return await api.post('Account/Login', User);

    }
    async getStateList() {
        return await api.get('UserList/GetStateList');
    }
    async GetSubscriptionList() {
        return await api.get('ManageCompany/GetSubscriptionList');
    }
    async countryList(masterNames, masterKeyText, userId) {
        return await api.get(`userList/GetMasterItems/${masterNames}/${masterKeyText}/${userId}`);
    }
    async GetPageSizeList() {
        let masterNames = 'PageSize';
        let masterKeyText = 'PageSize';
        let userId = localStorage.getItem('userId');
        return await api.get(`userList/GetMasterItems/${masterNames}/${masterKeyText}/${userId}`);

    }
    async getRolesName(id, companyId, UserId) {
        return await api.get(`UserList/GetRolesDropListByUserType/${id}/${companyId}/${UserId}`)
    }

    async getUserList(name, status, userType, sortColumn, sortDir, page, pageSize, userId, companyId) {
        if (typeof name == "undefined" || name == null || name == "") { name = "00Test"; }
        else { name = encodeURIComponent((name)); }
        return await api.get(`UserProfile/GetUsersList/${name}/${status}/${userType}/${sortColumn}/${sortDir}/${page}/${pageSize}/${userId}/${companyId}`);
    }
    getRoleList(RoleName, masternameId, status, searchUserType, sortColumn, sortDir, page, pageSize, userId, companyId) {

        userId = localStorage.getItem("switcheduserId");
        if (typeof RoleName == "undefined" || RoleName == null || RoleName == "") { RoleName = "00Test"; }
        return api.get(`Role/GetRoleList/${RoleName}/${masternameId}/${status}/${searchUserType}/${sortColumn}/${sortDir}/${page}/${pageSize}/${userId}/${companyId}`);
    }
    async getModuleList(userId, actionType = '00Test') {
        var loginSource = localStorage.getItem('loginSource');
        return await api.get(`Module/GetModuleList/${userId}/${actionType}/${loginSource}`);
       // return await api.get(`Module/GetModuleList/${userId}/${actionType}`);
    }
    async getRoleById(id, TypeOf, optionalParamers) {
        return await api.get(`Role/${id}/${TypeOf}/${optionalParamers}`);
    }

    async SaveRole(obj) {
        console.log('obj', obj)
        return await api.post('Role', obj);
    }

    async setRoleStatus(roleId, status, deletedRole, prefix, secondPrefix) {
        return await api.get(`Role/${roleId}/${status}/${deletedRole}/${prefix}/${secondPrefix}`)
    }


    async DeleteRole(roleId, deletedRole, prefix, secondPrefix, userId, companyId, IPAddress) {
        return await api.get(`Role/DeletedRoleById/${roleId}/${deletedRole}/${prefix}/${secondPrefix}/${userId}/${companyId}/${IPAddress}`)
    }
    async addeditUser(userModel, Id) {
        if (Id == null) {//add
            return await api.post(`userList/Register`, userModel);
        }
        else {//update
            return await api.post(`UserProfile/UpdateUser`, userModel);
        }
    }
    async getUserDetail(id, optional) {
        return await api.get(`UserProfile/GetUserDetailById/${id}/${optional}`);
    }

    async setsubadminStatus(id) {
        return await api.get(`UserActiveAndDelete/${id}`);
    }
    async SendRegitraionLink(id, email, companyId) {
        return await api.get(`UserProfile/SendRegitraionLink/${id}/${email}/${companyId}`);
    }
    async deleteuser(id, doptionalvalue, userId, companyId, IPAddress) {
        return await api.get(`UserActiveAndDelete/${id}/${doptionalvalue}/${userId}/${companyId}/${IPAddress}`);
    }
    async checkRoleNameIsExist(checkRoleNameIsExist) {
        return await api.post(`Role/CheckRoleNameIsExist`, checkRoleNameIsExist);
    }
    async ForgotPsw(forgotPswModel) {
        return await api.post(`Account/ForgotPassword`, forgotPswModel);
    }
    async resetPassword(resetPassword) {
        return await api.post(`Account/ResetPassword`, resetPassword);
    }

    async getExpenseVotingDashboard(expenseId, assetId, companyId) {
        return await api.get('Expense/voting-dashboard', {
            params: { expenseId: expenseId, assetId: assetId, companyId: companyId }
        });
    }

    async submitExpenseCoOwnerVote(model) {
        return await api.post('Expense/submit-expense-vote', model);
    }

    async getExpenseSettings(companyId) {
        return await api.get(`Expense/expense-settings/${companyId}`);
    }

    async saveExpenseSettings(model) {
        return await api.post('Expense/save-expense-settings', model);
    }

    async saveCoOwnerInvitation(model) {
        return await postWithChecklistCompletion(api, 'CoOwnerInvitation/SaveInvitation', model);
    }
    async getSentCoOwnerInvitations(searchFields, sortColumn, sortDir, pageIndex, pageSize, companyId, assetId) {
        const search = searchFields || '00Test';
        return await api.get(
            `CoOwnerInvitation/GetSentInvitations/${encodeURIComponent(search)}/${sortColumn}/${sortDir}/${pageIndex}/${pageSize}/${companyId}/${assetId}`
        );
    }
    async setPassword(setPassword) {
        return await api.post(`Account/SetPassword`, setPassword);
    }
    async ResetPassword(setPassword) {
        return await api.post(`Account/SetPassword`, setPassword);
    }
    async gettoken(email) {
        return await api.get(`UserProfile/gettoken/${email}`);
    }
    async GetRegitraionLink(id, email) {
        return await api.get(`UserProfile/GetRegitraionLink/${id}/${email}`);
    }

    async GetEmailSettings() {
        let companyId = localStorage.getItem('companyId');
        let userId = localStorage.getItem('userId');
        return await api.get(`EmailSettings/GetEmailSettings/${companyId}/${userId}`);
    }

    async SaveEmailSettings(emailSettingModel) {
        return await postWithChecklistCompletion(api, `EmailSettings/SaveEmailSettings`, emailSettingModel);
    }

    async SendEmail(model) {
        return await api.post(`EmailSettings/SendEmail`, model);
    }

    async GetTwilioSettings() {
        const companyId = localStorage.getItem('companyId');
        const userId = localStorage.getItem('userId');
        return await api.get(`TwilioSettings/GetTwilioSettings/${companyId}/${userId}`);
    }

    async SaveTwilioSettings(model) {
        return await api.post(`TwilioSettings/SaveTwilioSettings`, model);
    }

    async TestTwilioSms(model) {
        return await api.post(`TwilioSettings/TestTwilioSms`, model);
    }

    async GetSubscriptonList(searchFields, status, sortColumn, sortDir, page, pageSize, userId, companyId) {
        if (typeof searchFields == "undefined" || searchFields == null || searchFields == "") { searchFields = "00Test"; }
        return await api.get(`ManageSubscription/${searchFields}/${status}/${sortColumn}/${sortDir}/${page}/${pageSize}/${userId}/${companyId}`);

    }

    async getHeaderData(id, userIdentity) {
        userIdentity = localStorage.getItem('companyId');
        let actionType = "00Test";
        if (localStorage.getItem("actionType") == 'AsAObserver') {
            actionType = localStorage.getItem("actionType");
        }
        return await api.get(`Common/getHeaderData/${id}/${userIdentity}/${actionType}`);

    }
    async AddEditSubscription(subscriptionModel) {
        return await api.post(`ManageSubscription`, subscriptionModel);
    }

    async GetSubscriptionDetail(id) {
        return await api.get(`ManageSubscription/${id}`);
    }

    async getemailtemplateListing(emailTemplateName, sortColumn, sortDir, page, pageSize, userId) {
        if (typeof emailTemplateName == "undefined" || emailTemplateName == null || emailTemplateName == "") { emailTemplateName = "00Test"; }
        else { emailTemplateName = encodeURIComponent((emailTemplateName)); }
        var compaanyId = localStorage.getItem("companyId");
        return await api.get(`EmailTemplate/GetList/${emailTemplateName}/${sortColumn}/${sortDir}/${page}/${pageSize}/${userId}/${compaanyId}`);
    }
    async getDefaultEmailTemplatesForHtml() {
        return await api.get(`emailtemplatesForhtmlTemplates`);
    }
    async GetEmailTrakingList(emailTemplateName, sortColumn, sortDir, page, pageSize, userId, FromDateSearch, ToDateSearch, type) {

        if (typeof emailTemplateName == "undefined" || emailTemplateName == null || emailTemplateName == "") { emailTemplateName = "00Test"; }
        else { emailTemplateName = encodeURIComponent((emailTemplateName)); }
        var compaanyId = localStorage.getItem("companyId");
        return await api.get(`EmailTemplate/GetEmailTrakingList/${emailTemplateName}/${sortColumn}/${sortDir}/${page}/${pageSize}/${userId}/${compaanyId}/${FromDateSearch}/${ToDateSearch}/${type}`);
    }
    async addeditemailTemplate(userModel, Id) {
        if (Id == null) {//add
            return await api.post(`EmailTemplate/Post`, userModel);
        }
        else {//update
            return await api.post(`EmailTemplate/Post`, userModel);
        }
    }

    async getemailDetail(id) {
        var companyId = localStorage.getItem('companyId');
        return await api.get(`EmailTemplate/EmailTemplateById/${id}/${companyId}`);
    }
    async setSubscriptionStatus(subscriptionid, status) {
        console.log('status', status);
        return await api.get(`ManageSubscription/${subscriptionid}/${status}`)
    }

    async deleteSubscription(subscriptionid, prefix, userId, companyId, IPAddress, CurrentSelectLanguage) {
        return await api.get(`ManageSubscription/DeleteSubscriptions/${subscriptionid}/${prefix}/${userId}/${companyId}/${IPAddress}/${CurrentSelectLanguage}`)
    }
    async updateUserProfile(userProfile) {
        return await api.post(`UserProfile/UpdateUser`, userProfile);
    }

    async getCompanylist(searchModel) {
        return api.post(`ManageCompany/GetCompanyList`, searchModel);
    }
    async AddEditCompany(companyData) {
        console.log('company Data', companyData);
        return await api.post(`ManageCompany/AddEditCompany`, companyData);
    }
    async CheckDuplicateCompanyName(companyData) {
        return await api.post(`ManageCompany/CheckDuplicateCompanyName`, companyData);
    }
    async getCompanyProfile(companyId) {
        return await api.get(`CompanyProfile/GetCompanyProfile/${companyId}`);
    }
    async updateCompanyProfile(companyProfile) {
        return await api.post(`CompanyProfile/UpdateCompanyProfile`, companyProfile);
    }
    async GetCompanyDetail(id, userId) {
        return await api.get(`ManageCompany/GetCompanyDetailById/${id}/${userId}`);
    }
    async GetCompanyBrowserHistory(companyId, userId) {
        return await api.get(`ManageCompany/GetCompanyBrowserHistory/${companyId}/${userId}`);
    }
    async setcompanyadminStatus(id, status) {
        return await api.get(`ManageCompany/ActiveInactiveCompany/${id}/${status}`)
    }
    async getDashBoradData(userId, userType, currentselectedlanguage) {
        return await api.get(`ManageDashBoard/getDashBoradData/${userId}/${userType}/${currentselectedlanguage}`);
    }
    async PaySubscription(paySubscriptionModel) {
        return await api.post(`ManageDashBoard/PaySubscription`, paySubscriptionModel);
    }

    async GetSubscriptionCompanyList(SubscriptionId, searchModel) {
        return await api.post(`ManageSubscription/SubscriptoinWithCompany/${SubscriptionId}`, searchModel);

    }
    async SaveProfileFile(formData) {
        return await api.post(`UserProfile/SaveProfileFile`, formData, {
            "Content-Type": "multipart/form-data"
        });

    }
    async deleteCompany(id, userId, companyId, ipAddress) {
        return await api.get(`ManageCompany/DeleteCompanyByID/${id}/${userId}/${companyId}/${ipAddress}`);
    }
    async GetMembershipList(searchFields, status, sortColumn, sortDir, page, pageSize, userId, companyId) {
        if (typeof searchFields == "undefined" || searchFields == null || searchFields == "") { searchFields = "00Test"; }
        return await api.get(`Membership/${searchFields}/${status}/${sortColumn}/${sortDir}/${page}/${pageSize}/${userId}/${companyId}`);

    }
    async AddEditMembership(membershipModel) {
        return await api.post(`Membership`, membershipModel);
    }
    async GetMembershipDetail(id) {
        return await api.get(`Membership/${id}`);
    }
    async setMembershipStatus(membershipid, status) {
        return await api.get(`Membership/${membershipid}/${status}`)
    }
    async deleteMembership(membershipid, prefix, userid, companyid, IPAddress) {
        return await api.get(`Membership/DeleteMembership/${membershipid}/${prefix}/${userid}/${companyid}/${IPAddress}`)
    }

    async getBloglist(searchFields, categoryId, sortColumn, sortDir, pageIndex, pageSize, userId, companyId, status, languageId) {
        if (searchFields == '') { searchFields = '00Test' }
        return await api.get(`Blog/GetBlogsList/${searchFields}/${categoryId}/${sortColumn}/${sortDir}/${pageIndex}/${pageSize}/${userId}/${companyId}/${status}/${languageId}`);
    }
    async getBlogDatabyId(id, userId) {
        return await api.get(`Blog/${id}/${userId}`);
    }
    async getBlogcategorylist(userid, companyId, languageId) {
        return await api.get(`Blog/GetBlogCategoryDropDown/${userid}/${companyId}/${languageId}`);
    }
    async deleteblog(tablename, primaryKey, id, title, UserId, CompanyId, IPAddress) {
        return await api.get(`Blog/DeleteRecord/${tablename}/${primaryKey}/${id}/${title}/${UserId}/${CompanyId}/${IPAddress}`);
    }
    async setblogStatus(tablename, id, status, title) {
        return await api.get(`Blog/${tablename}/${id}/${status}/${title}`);
    }
    async Addupdateblog(blog) {
        return await api.post(`Blog/AddUpdateBlogs`, blog, {
            "Content-Type": "multipart/form-data"
        });
    }
    async GetTagsForBlogs(CompanyId) {
        return await api.get(`Blog/GetTagsForBlogs/${CompanyId}`);
    }
    async AddEditTagsForBlog(model) {
        return await api.post(`Blog/AddEditTagsForBlog`, model);
    }
    async tagsforbloglisting(search, sortBy, orderBy, pageIndex, pagesize, userid, companyId) {
        if (search == null || search === '') { search = '00Test'; }
        return await api.get(`Blog/tagsforbloglisting/${search}/${sortBy}/${orderBy}/${pageIndex}/${pagesize}/${userid}/${companyId}`)
    }
    async GetTagsById(Id) {
        return await api.get(`Blog/GetTagsById/${Id}`);
    }
    async DeleteTagsById(Id, UserId, CompanyId) {
        return await api.get(`Blog/DeleteTagsById/${Id}/${UserId}/${CompanyId}`);
    }
    async DeleteMultipleTagsById(Id) {
        return await api.post(`Blog/DeleteMultipleTagsById`, Id);
    }
    async getsubscriptionDetailsbycompanyId(companyId) {
        return await api.get(`GetSubscriptionbyCompanyId/${companyId}`);
    }
    async AddEdittestimonial(testimonialModel) {
        return await api.post(`ManageTestimonial/AddEdittestimonial`, testimonialModel);
    }

    async GetTestimonialData(Id) {
        return await api.get(`ManageTestimonial/GetTestimonialById/${Id}`);
    }
    async GetTestimonialList(searchFields, status, sortColumn, sortDir, page, pageSize, userId, companyId) {
        if (typeof searchFields == "undefined" || searchFields == null || searchFields == "") { searchFields = "00Test"; }
        return await api.get(`ManageTestimonial/GetTestimonialLists/${searchFields}/${status}/${sortColumn}/${sortDir}/${page}/${pageSize}/${userId}/${companyId}`);

    }
    async DeleteTestimonial(id) {
        return await api.get(`ManageTestimonial/DeleteTestimonial/${id}`)
    }
    async getsubscriptionPaymentDetails(searchModel) {
        return await api.post(`GetCompanyPaymentDetails`, searchModel);
    }
    async PaySubscriptionDuePayment(paySubscriptionModel) {
        return await api.post(`PaySubscriptionDuePayment`, paySubscriptionModel);
    }
    async cancelFreeTrialSubscription(cancelModel) {
        return await api.post(`subscription/cancel`, cancelModel);
    }
    async GetThemesList(companyId, userId) {
        return await api.get(`GetThemesList/${companyId}/${userId}`);
    }
    async SendCompanyRegitraionLink(id, email, companyId, companyUrl, paymentStatus, SubscriptionId) {
        return await api.post(`UserProfile/SendCompanyRegitraionLink`, companyUrl, {
            params: {
                id: id,
                email: email,
                companyId: companyId,
                paymentStatus: paymentStatus,
                SubscriptionId: SubscriptionId
            }
        });
    }
    async AddManageCourse(course) {
        return await api.post(`ManageCourse/AddManageCourse`, course, {
            "Content-Type": "multipart/form-data"
        });
    }
    async GetManageCourseList(searchFields, status, sortColumn, sortDir, page, pageSize, userId, companyId) {
        if (typeof searchFields == "undefined" || searchFields == null || searchFields == "") { searchFields = "00Test"; }
        return await api.get(`ManageCourse/${searchFields}/${status}/${sortColumn}/${sortDir}/${page}/${pageSize}/${userId}/${companyId}`);
    }
    async ChangeCourseStatusById(id, status) {
        return await api.get(`ManageCourse/ChangeCourseStatusById/${id}/${status}`)
    }
    async DeleteManageCourseById(id, UserId, CompanyId, IPAddress) {
        return await api.get(`ManageCourse/DeleteManageCourseById/${id}/${UserId}/${CompanyId}/${IPAddress}`)
    }
    async GetManageCourseById(id, userId, companyId) {
        return await api.get(`ManageCourse/GetManageCourseById/${id}/${userId}/${companyId}`);
    }
    async getcompanyuserlist(companyId) {

        return await api.get(`MonthlyContent/GetMonthlyContentDropdown/${companyId}`);
    }
    async Addupdatemonthlycontent(monthlyContent) {

        return await api.post(`MonthlyContent/AddManageMonthlyContent`, monthlyContent, {
            "Content-Type": "multipart/form-data"
        });
    }
    async getmonthlycontentlist(searchFields, sortColumn, sortDir, pageIndex, pageSize, loginuserid, companyId) {

        if (searchFields == '') { searchFields = '00Test' }
        return await api.get(`MonthlyContent/${searchFields}/${sortColumn}/${sortDir}/${pageIndex}/${pageSize}/${loginuserid}/${companyId}`);
    }
    async Deletemonthcontent(id, UserId, CompanyId, IPAddress) {
        return await api.get(`MonthlyContent/DeleteMonthlyContentById/${id}/${UserId}/${CompanyId}/${IPAddress}`);
    }
    async setcontentStatus(id, InStatus) {

        return await api.get(`MonthlyContent/ChangeMonthlyContentStatusById/${id}/${InStatus}`);
    }
    async getmonthlycontentDatabyId(id, companyId, userId) {
        return await api.get(`MonthlyContent/GetMonthlyContentById/${id}/${companyId}/${userId}`);
    }
    async GetDynamicContentForComapny(companyId, userId, CurrentSelectLanguage) {
        return await api.get(`ManageCompanyWebPage/GetDynamicContent/${companyId}/${userId}/${CurrentSelectLanguage}`);
    }
    async SaveDynamicContentForComapny(DynamicContetData) {
        return await postWithChecklistCompletion(api, `ManageCompanyWebPage/SaveDynamicContentForComapny`, DynamicContetData, {
            "Content-Type": "multipart/form-data"
        });
    }
    async AddEditTrainingcategory(TrainingCategoryModel) {
        debugger;
        return await api.post(`Training/AddEditTrainigCategory`, TrainingCategoryModel);
    }

    async gettrainingCategorylist(objData) {
        debugger;
        return await api.get(`Training/GetTrainigCategoryList/${objData}`);
    }

    async GetTrainingCategoryDetail(TrainingCategoryId) {
        return await api.get(`Training/GetTraingCategoriesByID/${TrainingCategoryId}`);
    }

    async deleteTrainingCategory(TrainingCategoryId, UserId, CompanyId, IPAddress) {
        return await api.get(`Training/DeleteTrainingCategory/${TrainingCategoryId}/${UserId}/${CompanyId}/${IPAddress}`)
    }

    async setTrainingCategoryStatus(TrainingCategoryId, status) {
        return await api.get(`Training/ChangeStatus/${TrainingCategoryId}/${status}`)

    }

    async GetTrainingList(Title, statusValue, pageIndex, pageSize, sortBy, orderBy, userId, TrainingFor, companyId, categoryId, location) {
        return await api.get(`Training/GetTrainingList/${Title}/${statusValue}/${pageIndex}/${pageSize}/${sortBy}/${orderBy}/${userId}/${TrainingFor}/${companyId}/${categoryId}/${location}`)

    }

    async GetviewTrainingList(Title, pageIndex, pageSize, sortBy, orderBy, userId, companyId, categoryId) {
        return await api.get(`Training/ViewTrainingList/${Title}/${pageIndex}/${pageSize}/${sortBy}/${orderBy}/${userId}/${companyId}/${categoryId}`)

    }

    async SaveFile(formData) {
        return await api.post(`Training/SaveFile`, formData, {
            "Content-Type": "multipart/form-data"
        });
    }

    async SaveUpdateTraining(ManageTrainingModel) {
        return await api.post(`Training/SaveUpdateTraining`, ManageTrainingModel)

    }


    async GetTrainingDetailByID(id) {
        debugger;
        return await api.get(`Training/GetTrainingDetailByID/${id}`);
    }

    async GetTrainngCategory() {

        return await api.get(`Training/GetTrainingCategoryDropDown`);
    }
    async DeleteTraining(id, UserId, CompanyId, IPAddress) {
        return await api.get(`Training/DeleteTrainingDetail/${id}/${UserId}/${CompanyId}/${IPAddress}`);
    }
    async GetDropDownListData(refcode, UserId, CompanyId) {
        return await api.get(`Training/GetCommonDropDownListData/${refcode}/${UserId}/${CompanyId}`)
    }

    async DownloadSingleFile(docname, userId, companyId,) {
        return await api.get(`Training/DownloadDoc/${docname}/${userId}/${companyId}}`, { responseType: 'blob' })
    }
    async UpdateTrainingStatus(id, status) {
        return await api.get(`Training/ChangeStatusById/${id}/${status}`)

    }
    async SendMessage(objCommunication) {
        debugger;
        return await api.post(`Communication/SendMessage`, objCommunication, {
            "Content-Type": "multipart/form-data"
        });
    }

    async GetMessagesList(searchFields, sortColumn, sortDir, pageIndex, pageSize, companyId, userId, isListMode) {
        debugger;
        return await api.get(`Communication/GetUserCommunicationList/${searchFields}/${sortColumn}/${sortDir}/${pageIndex}/${pageSize}/${companyId}/${userId}/${isListMode}`)
    }

    async GetUsersByUserType(UserId, CompanyId, UserTypeId = '') {
        return await api.get(`Communication/GetUsersByUserType/${UserId}/${CompanyId}/${UserTypeId}`)
    }
    async GetUsertypeId(refcode, UserId, CompanyId) {
        debugger;
        return await api.get(`Communication/GetUserTypes/${refcode}/${UserId}/${CompanyId}`)
    }
    async GetUserCommunicationDetailById(Id, UserId) {
        debugger;
        return await api.get(`Communication/GetUserCommunicationDetailById/${Id}/${UserId}`)
    }
    async GetUserCommunicationThreadsById(Id, UserId) {
        debugger;
        return await api.get(`Communication/GetUserCommunicationThreadsById/${Id}/${UserId}`)
    }
    async DeleteMessageUserWise(ID, UserId, CompanyId, ipaddress) {
        return await api.get(`Communication/DeleteMessageUserWise/${ID}/${UserId}/${CompanyId}/${ipaddress}`);
    }
    async getDashBoradCompanyUrlName(userId, userType) {
        return await api.get(`ManageDashBoard/GetCompanyListAndUrl/${userId}/${userType}`);
    }

    async GetDashboardWidgetForAddeditforuser(model) {
        debugger;
        return await api.post(`DashboardDynamicVisit/GetDashboardWidgetForAddeditforuser`, model);

    }
    async GetDashboardWidgetForAddeditforuser_Render(model) {
        return await api.post(`DashboardDynamicVisit/GetDashboardWidgetForAddedituserList`, model);
    }
    async FAQservice(jsonFAQ, companyId, userId) {

        return await api.post(`FrequentlyAskedQuestions/ManageFAQ/${jsonFAQ}/${companyId}/${userId}`, {

        });
    }
    async AddEditFAQ(FAqdata) {
        return await api.post(`FrequentlyAskedQuestions/AddupdateFAQ`, FAqdata)
    }
    async getFAQDetail(id, userId) {
        return await api.get(`FrequentlyAskedQuestions/GetFAQDetail/${id}/${userId}`);
    }
    async DownloadAttachmentFile(docname, userId, companyId) {
        return await api.get(`Communication/DownloadDoc/${docname}/${userId}/${companyId}`, { responseType: 'blob' })
    }
    async SaveFunctionalPrincipleContent(widgetData) {
        return await api.post(`ManageCompanyWebPage/SaveFunctionalPrincipleContent`, widgetData, {
            "Content-Type": "multipart/form-data"
        });
    }

    async SaveWhoweareContent(WhoWeareData) {
        return await api.post(`ManageCompanyWebPage/SaveWhoweareContent`, WhoWeareData, {
            "Content-Type": "multipart/form-data"
        });
    }
    async GetInvociePaymentList(searchModel) {
        return await api.post(`GetInvociePaymentList`, searchModel);
    }
    async downloadInvoice(companyid, userid, companylogo) {
        return await api.get(`manageCompany/DownloadUserInvoicePdf/${companyid}/${userid}/${companylogo}`, { responseType: 'blob' });
    }
    async ViewInvoice(companyid, userid, companylogo) {
        return await api.get(`manageCompany/ViewUserInvoicePdf/${companyid}/${userid}/${companylogo}`);
    }
    async downloadPackagePayementHistoryInvoice(Id, companyid, userid, companylogo) {
        return await api.get(`ManageSubscription/DownloadSinglePaymentDetailInvoice/${Id}/${companyid}/${userid}/${companylogo}`, { responseType: 'blob' });
    }
    async downloadExcel(records, filename, firstListHeader, secondListHeader) {
        return await api.post(`Common/ExportExcelForMemberShip/${filename}/${firstListHeader}/${secondListHeader}`, records, { responseType: 'blob' });
    }
    async downloadMembershipInvoice(companyid, userid) {
        return await api.get(`ManageSubscription/DownloadMembershipInvoiceData/${companyid}/${userid}`, { responseType: 'blob' });
    }
    async getCommissionReport(searchModel) {
        debugger
        return await api.post(`CompanyDashboard/CommisionListing`, searchModel);
    }
    async ExportData(records, type, filename, pageLength = "") {
        if (type == 'Excel') {
            api.post(`Common/ExportExcelInvoice/${type}/${filename}/${pageLength}`, records, { responseType: 'blob' }).then(response => {
                saveAs(response.data, filename + ".xlsx")
            })
        }
        else if (type == 'CSV') {
            api.post(`Common/ExportExcelInvoice/${type}/${filename}/${pageLength}`, records, { responseType: 'blob' }).then(response => {
                saveAs(response.data, filename + ".csv")

            })
        }
        else if (type == 'PDF') {
            api.post(`Common/ExportExcelInvoice/${type}/${filename}/${pageLength}`, records, { responseType: 'blob' }).then(response => {
                saveAs(response.data, filename + ".pdf")
            })
        }
    }

    async addVendorUser(vendormodel) {
        return await postWithChecklistCompletion(api, `ManageVendor/RegisterVendor`, vendormodel);
        //if (vendormodel.Id == null) {

        //}
        //else {//update
        //    return await api.post(`UserProfile/UpdateUser`, vendormodel);
        //}
    }
    //GetSubAdminList
    async GetSubAdminList(searchFields, sortColumn, sortDir, pageIndex, pageSize, statusId, loginuserid, companyId, userType) {
        return await api.get(`ManageVendor/GetSubAdminList/${searchFields}/${sortColumn}/${sortDir}/${pageIndex}/${pageSize}/${statusId}/${loginuserid}/${companyId}/${userType}`)
    }
    async GetSubAdminListByVendor(ScheduleId,searchFields, sortColumn, sortDir, pageIndex, pageSize, statusId, companyId, vendorId, serviceId) {
        return await api.get(`ManageVendor/GetSubAdminListByVendor/${ScheduleId}/${searchFields}/${sortColumn}/${sortDir}/${pageIndex}/${pageSize}/${statusId}/${companyId}/${vendorId}/${serviceId}`)
    }
    async GetVendorList(searchModel) {
        return await api.post(`ManageVendor/GetvendorList`, searchModel)
    }
    async setVendorStatus(id, status) {
        return await api.get(`ManageVendor/ChangeVendorStatus/${id}/${status}`)
    }
    async GetvendorDetail(AspNetId, UserId, companyId) {
        return await api.get(`ManageVendor/GetVendorDeatilById/${AspNetId}/${UserId}/${companyId}`);
    }
    async GetCompaniesList() {
        return await api.get(`ManageVendor/GetCompaniesList`);
    }
    async GetWorkTypeCategorysList(companyId) {
        return await api.get(`ManageVendor/GetWorkTypeCategorysList/${companyId}`);
    }
    async GetVendorServicesList(model) {
        return await api.post(`ManageVendor/GetVendorServicesList`, model);
    }
    async addSubAdminUser(vendormodel) {
        return await api.post(`ManageVendor/RegisterVendorSubUser`, vendormodel);
    }
    async deleteSubadmin(id, doptionalvalue, userId, companyId, IPAddress) {
        return await api.get(`UserActiveAndDelete/${id}/${doptionalvalue}/${userId}/${companyId}/${IPAddress}`);
    }
    async getSkillsList(company) {
        return await api.get(`ManageVendor/GetSkillsDropdown/${company}`);
    }
    async AddServiceVendor(Model) {
        return await postWithChecklistCompletion(api, `ManageVendor/AddEditServiceVendor`, Model);
    }
    async GetServiceVendorList(searchFields, sortColumn, sortDir, pageIndex, pageSize, loginuserid, companyId) {
        return await api.get(`ManageVendor/GetServicevendorList/${searchFields}/${sortColumn}/${sortDir}/${pageIndex}/${pageSize}/${loginuserid}/${companyId}`)
    }
    ///GetServiceVendorList
    async GetAddOnChargesList(searchFields, sortColumn, sortDir, pageIndex, pageSize, loginuserid, companyId) {
        return await api.get(`news/GetAddOnChargesList/${searchFields}/${sortColumn}/${sortDir}/${pageIndex}/${pageSize}/${loginuserid}/${companyId}`)
    }
    async getSerivceVendordatabyId(id) {
        return await api.get(`ManageVendor/GetServiceVendorDetailById/${id}`);
    }
    async Addworkingtypecategory(model) {
        return await api.post(`ManageVendor/Addworkingtypecategory`, model);
    }
    async workingtypecategoryList(search, sortBy, orderBy, pageIndex, pagesize, userid, companyId) {
        return await api.get(`ManageVendor/workingtypecategoryList/${search}/${sortBy}/${orderBy}/${pageIndex}/${pagesize}/${userid}/${companyId}`)
    }
    async GetTicketNotesList(ticketId, companyId, search, pageIndex, pageSize) {
        debugger;
        return await api.get(`ManageTicket/GetTicketNotesList/${ticketId}/${companyId}/${search}/${pageIndex}/${pageSize}`)
    }
    async SaveTicketNotes(TicketPaymentModal) {
        debugger;
        return await api.post(`ManageTicket/SaveTicketNotes`, TicketPaymentModal)
    }
    async GetWorkTypeCategoryById(Id) {
        return await api.get(`ManageVendor/GetWorkTypeCategoryById/${Id}`);
    }
    async ServiceVendorSingleDelete(id, UserId, CompanyId, ServiceIPAddress) {
        return await api.get(`ManageVendor/DeleteServiceVendor/${id}/${UserId}/${CompanyId}/${ServiceIPAddress}`)
    }
    async ServiceVendormultipleDelete(ids) {
        return await api.post(`ManageVendor/MultipleDeleteServiceVendor`, ids);
    }
    async DeleteWorkTypeCategoryById(Id, UserId, CompanyId, IPAddress) {
        return await api.get(`ManageVendor/DeleteWorkTypeCategoryById/${Id}/${UserId}/${CompanyId}/${IPAddress}`);
    }
    async GetFeeTypeList() {
        let masterNames = 'VendorFeeType';
        let masterKeyText = 'VendorFeeType';
        let userId = localStorage.getItem('userId');
        return await api.get(`userList/GetMasterItems/${masterNames}/${masterKeyText}/${userId}`);
    }
    async DeleteVendorUser(id, AspNetId, userId, companyId, ipaddress) {
        return await api.get(`ManageVendor/DeleteVendorUser/${id}/${AspNetId}/${userId}/${companyId}/${ipaddress}`);
    }
    async GetIpAddressForUsers() {
        return await fetch('https://api.ipify.org?format=json');


    }
    async GetIPAddress() {
        try {
            const response = await fetch('https://api.ipify.org?format=json');
            const data_res = await response.json();
            if (data_res != null) {
                return data_res.ip;
            } else {
                return "::1";
            }
        } catch (error) {
            console.error("Error fetching IP:", error);
            return "::1";
        }
    }
    //async GetIPAddress() {
    //    const response = await fetch('https://api.ipify.org?format=json');
    //    const data_res = await response.json();
    //    if (data_res != null) {
    //        return await data_res.ip;
    //    }
    //    else {
    //        return await "::1";
    //    }

    //}
    async setVendorSubAdminStatus(id, status) {
        return await api.get(`ManageVendor/ChangeVendorSubAdminStatus/${id}/${status}`)
    }
    async SendVendorRegitraionLink(id, companyId) {
        return await api.get(`ManageVendor/SendVendorRegitraionLink/${id}/${companyId}`);
    }
    async GetRegitraionLink(id) {
        return await api.get(`ManageVendor/GetVendorRegitraionLink/${id}`);
    }
    async DeleteMultipleWorkTypeCategoryById(Id) {
        return await api.post(`ManageVendor/DeleteMultipleWorkTypeCategoryById`, Id);
    }
    async GetvendorSubAdminDetail(AspNetId, companyId) {
        return await api.get(`ManageVendor/GetVendorSubAdminDeatilById/${AspNetId}/${companyId}`);
    }
    async DeleteFeetype(Id, UserId, CompanyId, FeeTypeIPAddress) {
        return await api.get(`ManageVendor/DeleteFeetype/${Id}/${UserId}/${CompanyId}/${FeeTypeIPAddress}`);
    }
    async GetFeeVendorDropdown(search, sortBy, orderBy, pageIndex, pagesize, userid, companyId) {
        debugger;
        return await api.get(`ManageVendor/getlistfeetype/${search}/${sortBy}/${orderBy}/${pageIndex}/${pagesize}/${userid}/${companyId}`)
    }
    async Addfeetype(feeType) {
        return await api.post(`ManageVendor/Addfeetype`, feeType);
    }
    async GetFeeVendorList(search, sortBy, orderBy, pageIndex, pagesize, userid, companyId) {
        debugger;
        return await api.get(`ManageVendor/getlistfeetype/${search}/${sortBy}/${orderBy}/${pageIndex}/${pagesize}/${userid}/${companyId}`)
    }
    async GetFeetypeDetailById(Id) {
        return await api.get(`ManageVendor/GetFeetypeDetailById/${Id}`)
    }
    async MultipleDeleteFeetype(Id) {
        return await api.post(`ManageVendor/MultipleDeleteFeetype`, Id);
    }
    async ReAssignTicket(ReAssignId, Id, companyId, userId, ticketId, scheduleId, assetId) {
        return await api.get(`ManageTicket/ReAssignTicket/${ReAssignId}/${Id}/${companyId}/${userId}/${ticketId}/${scheduleId}/${assetId}`)
    }
    async AssignAgents(payload) {
        return await api.post(`ManageTicket/AssignAgents`, payload)
    }
    async getDashBoradVendoragent(userId, userType) {
        return await api.get(`ManageDashBoard/getDashBoradDataforVendor/${userId}/${userType}`);
    }
    async getUnreadNotification(userId) {

        return await api.get(`ManageDashBoard/getunreadcount/${userId}`);
    }
    async GetunreadNotificationList(userId, CompanyId) {
        debugger;
        return await api.get(`ManageDashBoard/GetUnreadnotificationList/${userId}/${CompanyId}`);
    }
    async ChangeNotificationStatusById(userId, status) {
        return await api.get(`ManageNotification/ChangeNotificationStatusById/${userId}/${status}`)

    }
    async getunreadnotficationforvendor(userId, CompanyId) {
        return await api.get(`ManageDashBoard/getunreadnotficationforvendor/${userId}/${CompanyId}`);
    }
    async GetMembersList(MembershipID, MembersFilter, MembersortColumn, MembersortDir, Memberspagenumber, MemberspageSizeValue, userId, companyId) {
        return await api.get(`Membership/GetMembersList/${MembershipID}/${MembersFilter}/${MembersortColumn}/${MembersortDir}/${Memberspagenumber}/${MemberspageSizeValue}/${userId}/${companyId}`);

    }
    async GetSupInvociePackageList(searchModel) {
        return await api.post(`GetSupInvociePackageList`, searchModel);
    }
    async ViewCompanyInvoiceDetail(companyId, userId) {
        return await api.get(`ManageSubscription/ViewcompanyInvoice/${companyId}/${userId}`);
    }
    async DownloadCompanyInvoice(companyid, userId) {
        return await api.get(`ManageSubscription/DownloadCompanyInvoice/${companyid}/${userId}`, { responseType: 'blob' });
    }
    async GetTrainingList(Title, statusValue, pageIndex, pageSize, sortBy, orderBy, userId, TrainingFor, companyId, categoryId, location) {
        return await api.get(`Training/GetTrainingList/${Title}/${statusValue}/${pageIndex}/${pageSize}/${sortBy}/${orderBy}/${userId}/${TrainingFor}/${companyId}/${categoryId}/${location}`)

    }
    async GetDropDownListViewData(UserId, CompanyId) {
        return await api.get(`Training/GetCommonDropDownforView/${UserId}/${CompanyId}`)
    }
    async ViewMembershipInvoiceUser(companyid, userid) {
        return await api.get(`ManageSubscription/ViewMembershipInvoiceUser/${companyid}/${userid}`);
    }
    async Logout(userid) {
        return await api.get(`Account/Logout/${userid}`)
    }
    async ViewSingleAssetPublishedInvoice(Id, tranId, companyId, UserId, companylogo) {
        return await api.get(`manageCompany/ViewSingleAssetPublishedInvoicePdf/${Id} /${tranId}/${companyId}/${UserId}/${companylogo}`);
    }
    async DownloadSingleAssetPublishedInvoicInvoice(Id, tranId, companyId, UserId, companylogo) {
        return await api.get(`manageCompany/DownloadSingleAssetPublishedInvoicePdf/${Id}/${tranId}/${companyId}/${UserId}/${companylogo}`, { responseType: 'blob' });
    }
    async GetGatewayPaymentSetting(companyId) {
        return await api.get(`CompanyUsers/GetGatewayPaymentSetting/${companyId}`)
    }
    async ExportData(records, type, filename, pageLength = "") {
        if (type == 'Excel') {
            api.post(`Common/ExportExcelInvoice/${type}/${filename}/${pageLength}`, records, { responseType: 'blob' }).then(response => {
                saveAs(response.data, filename + ".xlsx")
            })
        }
        else if (type == 'CSV') {
            api.post(`Common/ExportExcelInvoice/${type}/${filename}/${pageLength}`, records, { responseType: 'blob' }).then(response => {
                saveAs(response.data, filename + ".csv")

            })
        }
        else if (type == 'PDF') {
            api.post(`Common/ExportExcelInvoice/${type}/${filename}/${pageLength}`, records, { responseType: 'blob' }).then(response => {
                saveAs(response.data, filename + ".pdf")
            })
        }

    }
    async Importvendor(Json) {
        debugger;
        return await api.post(`ManageVendor/Importvendor`, Json);
        //if (vendormodel.Id == null) {

        //}
        //else {//update
        //    return await api.post(`UserProfile/UpdateUser`, vendormodel);
        //}
    }
    async LogoutHistory(userId, IPAddress) {
        return await api.get(`account/LogOutHostoryForUsers/${userId}/${IPAddress}`)
    }

    async LoginHostoryForUsers(model) {
        return await api.post('Account/LoginHostoryForUsers', model);
    }
    async UpdateUserName(model) {
        return await api.post(`manageCompany/UpdateUserName`, model);
    }
    async DeleteMappedAssets(UserId, mappedId, companyId, ipAddress) {
        debugger;
        return await api.get(`ManageAsset/DeleteMappedAssets/${mappedId}/${UserId}/${companyId}/${ipAddress}`);
    }
    async getAllCompanyUsers(masterNames, masterKeyText, userId) {
        return await api.get(`userList/GetMasterItems/${masterNames}/${masterKeyText}/${userId}`);
    }
    GetAssetDetail(assetId, userId, ipAddress) {
        debugger;
        return api.get(`ManageAsset/GetAssetDetail/${assetId}/${userId}/${ipAddress}`);
    }
    //GetAssetDetail(assetId, userId, ipAddress) {
    //    debugger;
    //    return api.post(`ManageAsset/GetAssetDetail/${assetId}/${userId}/${ipAddress}`);
    //}
    AddShareCashOwner(model) {
        debugger;
        return api.post(`ManageAsset/AddShareCashOwner`, model);
    }
    async getMasterItemList(masterKey, masterNameText, userId, companyId) {
        return await api.get(
            `Common/GetMasterItemList/${masterKey}/${masterNameText}/${userId}/${companyId}`
        );
    }
    addQuickSearch(model) {
        debugger;
        return api.post(`ManageSetting/AddQuickSearchSettings`, model);
    }
    async GetQuickList(companyid) {
        return await api.get(`ManageSetting/GetQuickSearchList/${companyid}`)
    }
    async GetLanguageList(masterNames, masterKeyText, userId) {
        return await api.get(`userList/GetMasterItems/${masterNames}/${masterKeyText}/${userId}`);
    }
    async UpdateLanguageId(model) {

        return await api.post(`CompanyUsers/UpdateLanguageId`, model);
    }
    async userLoginHistory(name, username, fromdate, todate, sortColumn, sortDir, page, pageSize, userId, companyId) {
        var companyId = localStorage.getItem('companyId');
        return await api.get(`Blog/GetUserLoginHistoryList/${name}/${username}/${fromdate}/${todate}/${sortColumn}/${sortDir}/${page}/${pageSize}/${userId}/${companyId}`);
    }
    async manageServer() {

        return await api.get(`BlogCategories/GetNames`);
    }
    async postData() {

        return await api.get(`BlogCategories/postData`);
    }
    async SaveWidget(model) {
        debugger;
        return await api.post(`DashboardDynamicVisit/SaveWidget`, model);

    }
    async GetOwnrezBookingList(search, status, sortColumn, sortDir, page, pageSize, userId) {
        var companyId = localStorage.getItem('companyId');
        debugger;
        return await api.get(`OwnerezProperty/GetOwnerezBookingList/${search}/${status}/${sortColumn}/${sortDir}/${page}/${pageSize}/${userId}/${companyId}`);
    }
    async getQuotelisting(search, status, sortColumn, sortDir, page, pageSize, userId) {
        debugger
        var companyid = localStorage.getItem('companyId');
        return await api.get(`OwnerezProperty/GetQuoteListing/${search}/${status}/${sortColumn}/${sortDir}/${page}/${pageSize}/${userId}/${companyid}`);
    }
    async AddEditPricingPreferences(AddPricingPrefModel) {
        debugger;
        return await api.post(`OwnerezProperty/AddEditPricingPreferences`, AddPricingPrefModel);
    }
    async GetPricingPreferencesDetail(UserId, companyId) {
        debugger
        return await api.get(
            `OwnerezProperty/GetPricingPreferencesDetail/${UserId}/${companyId}`
        );
    }
    async GetMasterItemsForMultiUsers(masterNames, companyId, userId, Flag) {
        debugger;
        return await api.get(`common/GetMasterItemsForMultiUsers/${masterNames}/${companyId}/${userId}/${Flag}`)
    }
    async GetQuotePaymentInvoice(quoteId, userId, companyId, Type) {
        if (Type == 'PDF')
            return await api.get(`OwnerezProperty/GetQuotePaymentInvoice/${quoteId}/${userId}/${companyId}/${Type}`, { responseType: 'blob' });
        else
            return await api.get(`OwnerezProperty/GetQuotePaymentInvoice/${quoteId}/${userId}/${companyId}/${Type}`);
    }
    async DeleteMultipleAddOnChargeById(Id) {
        return await api.post(`News/DeleteMultipleAddOnChargeById`, Id);
    }
    async DeleteAddOnChargecategoryById(Id, UserId, CompanyId, IPAddress) {
        debugger;
        return await api.get(`News/DeleteAddOnChargecategoryById/${Id}/${UserId}/${CompanyId}/${IPAddress}`);
    }
    async MultipleAddOnChargeDeleteById(Id) {
        return await api.post(`News/MultipleAddOnChargeDeleteById`, Id);
    }
    async DeleteAddOnChargeById(Id, UserId, CompanyId, IPAddress) {
        debugger;
        return await api.get(`News/DeleteAddOnChargeById/${Id}/${UserId}/${CompanyId}/${IPAddress}`);
    }
    async getAddOnChargeStatusById(Id) {
        debugger;
        return await api.get(`News/getAddOnChargeStatusById/${Id}`);
    }
    async GetSummaryReportslisting(searchModel) {
        debugger;
        return await api.post(`ManageReports/GetSummaryReportslisting`, searchModel);
    }

    async ExportData(records, type, filename, pageLength = "") {
        const resolvedPageLength = pageLength == null ? '' : pageLength;
        const url = `Common/ExportExcelInvoice/${type}/${filename}/${resolvedPageLength}`;
        let extension = '';

        if (type == 'Excel') {
            extension = '.xlsx';
        }
        else if (type == 'CSV') {
            extension = '.csv';
        }
        else if (type == 'PDF') {
            extension = '.pdf';
        }
        else if (type == 'TSV') {
            extension = '.tsv';
        }
        else {
            throw new Error('Unsupported export type');
        }

        const response = await api.post(url, records, { responseType: 'blob' });
        saveAs(response.data, filename + extension);
    }
    async GetCouponCodeTrackingReport(searchModel) {
        return await api.get(`Reports/GetCouponCodeTrackingReportListing`, { params: searchModel });
    }
    async GetPropertyType(companyId) {
        return await api.get(`ManageReports/GetAssetCategory/${companyId}`)
    }
    async GetPropertylistDrp(model) {
        return await api.post(`ManageReports/GetAssetListDropdown`, model)
    }
    async GetManageGroupListforVendor(companyId) {
        return await api.get(`ManageVendor/GetManageGroupListforVendor/${companyId}`);
    }
    async AddChecklist(model) {
        debugger;
        return await api.post(`HouseKeeping/AddChecklist`, model);

    }
    async getWorkTypeList(companyId, userId) {
        return await api.get(`ManageVendor/GetWorkTypeDropdown/${companyId}/${userId}`);
    }
    async CheckListDropdown(companyId) {
        return await api.get(`HouseKeeping/GetCheckListDrp/${companyId}`);
    }
    async GetAgentServicesList(model) {
        return await api.post(`ManageVendor/GetAgentServiceDropdown`, model)
    }
    async HousekeepingVendorDropdown(companyId, workTypeId, serviceId) {
        return await api.get(`HouseKeeping/GetHouskeepingVendorDrp/${companyId}/${workTypeId}/${serviceId}`);
    }
    async AddChecklistAnswer(model) {
        return await api.post(`HouseKeeping/AddChecklistAnswer`, model);

    }

    async GetAssignedAgentList(ScheduleId,searchFields, sortColumn, sortDir, pageIndex, page, statusId, loginuserid, companyId) {
        debugger;
        return await api.get(`HouseKeeping/GetAssignedAgentList/${ScheduleId}/${searchFields}/${sortColumn}/${sortDir}/${pageIndex}/${page}/${statusId}/${loginuserid}/${companyId}`)
    }
    async CancelScheduleTask(model) {
        debugger;
        return await api.post(`HouseKeeping/AddCancelScheduleTask`, model)
    }

    async GetDetailsByAssetId(assetId, compnyId) {
        return await api.get(`HouseKeeping/GetDetailsByAssetId/${assetId}/${compnyId}`)

    }
   
    async GetManageTimeSlotsList(userId, companyId) {
        debugger;
        //return await api.get(`ManageTimeSlot/GetManageTimeSlotsList/${userId}`);
        return await api.get(`Newsletter/GetTimeSlot/${userId}`);
    }
    async AddTimeSlot(Model) {
        debugger;
        return await api.post(`ManageTimeSlot/AdddTimeSlot`, Model);
    }
    async AddExcludesDays(Model) {
        debugger;
        return await api.post(`ManageTimeSlot/addEditExcludedday`, Model);
    }
    async GetExcludedList(Model) {
        debugger;
        return await api.post(`ManageTimeSlot/GetExcludedList`, Model);
    }
   
    async GetExcludedListById(userId, excludeddateId) {
        debugger;
        return await api.get(`ManageTimeSlot/GetExcludedListById/${userId}/${excludeddateId}`);
    }
    async DeleteExcludedateById(userId, excludeddateId) {
        debugger;
        return await api.get(`ManageTimeSlot/DeleteExcludedateById/${userId}/${excludeddateId}`);
    }
    async GetPikupList(companyId, userId, startDate, endDate, Mode) {
        debugger;
        return await api.get(`GolfCart/GetPikupDetail/${companyId}/${userId}/${startDate}/${endDate}/${Mode}`);
    }
    async GetRetrunList(companyId, userId, RetrunstartDate, RetrunendDate, Mode) {
        debugger;
        return await api.get(`GolfCart/GetReturnDetail/${companyId}/${userId}/${RetrunstartDate}/${RetrunendDate}/${Mode}`);
    }
    async GetBookNumberDetails(BookingNumber) {
        debugger;
        return await api.get(`GolfCart/GetAssetDetailByABookNumber/${BookingNumber}`);
    }

    async getExpenseList(companyId, assetId, title, dateFrom, dateTo, page, pageSize, sortColumn, sortDir, expenseFilter) {
        debugger;
        const loginSource = localStorage.getItem('loginSource');

        if (loginSource === 'Mobile') {
            pageSize = 1000;
        }
        const params = {
            companyId: companyId,
            page: page,
            pageSize: pageSize,
            sortColumn: sortColumn || 'CreatedOn',
            sortDir: sortDir || 'desc'
        };
        if (assetId) { params.assetId = assetId; }
        if (title) { params.title = title; }
        if (dateFrom) { params.dateFrom = dateFrom; }
        if (dateTo) { params.dateTo = dateTo; }
        if (expenseFilter) { params.expenseFilter = expenseFilter; }
        return await api.get('Expense/list', { params: params });
    }

    async getExpenseAndDueList(searchFields, sortColumn, sortDir, page, pageSize, userId, companyId, paymentStatus) {
        debugger;
        const loginSource = localStorage.getItem('loginSource');

        if (loginSource === 'Mobile') {
            pageSize = 1000;
        }
        const params = {
            searchFields: (typeof searchFields == "undefined" || searchFields == null || searchFields == "") ? "00Test" : searchFields,
            sortColumn: sortColumn,
            sortDir: sortDir,
            page: page,
            pageSize: pageSize,
            userId: userId,
            companyId: companyId,
            loginSource: loginSource
        };
        if (paymentStatus) {
            params.paymentStatus = paymentStatus;
        }
        return await api.get('Expense/expensedue', { params: params });
    }

    async getExpenseById(id, userId, options = {}) {
        const resolvedUserId = userId || localStorage.getItem('userId');
        const params = {};
        if (options.status != null && options.status !== '') {
            params.status = options.status;
        }
        if (options.myShare != null && options.myShare !== '' && !isNaN(Number(options.myShare))) {
            params.myShare = Number(options.myShare);
        }
        return await api.get(`Expense/${id}/${resolvedUserId}`, { params });
    }

    async addExpense(model) {
        debugger;
        return await api.post('Expense/add', model);
    }

    async addHouseholdExpense(model) {
        return await api.post('Expense/household-add', model);
    }

    async parseHouseholdReceipt(file) {
        const fd = new FormData();
        fd.append('file', file);
        return await api.post('Expense/parse-receipt', fd, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    }

    async updateExpense(model) {
        debugger;
        return await api.put('Expense/update', model);
    }

    async deleteExpense(body) {
        return await api.post('Expense/delete', body);
    }

    async getExpensePaymentTracking(companyId, expenseId, page, pageSize, search, sortColumn, sortDir) {
        const params = { companyId: companyId, page: page, pageSize: pageSize };
        if (expenseId != null && expenseId !== '' && !isNaN(Number(expenseId))) {
            params.expenseId = Number(expenseId);
        }
        if (search) { params.search = search; }
        if (sortColumn) { params.sortColumn = sortColumn; }
        if (sortDir) { params.sortDir = sortDir; }
        return await api.get('Expense/payment-tracking', { params: params });
    }

    async getExpensePaymentSummary(companyId, expenseId) {
        const params = { companyId: companyId };
        if (expenseId != null && expenseId !== '' && !isNaN(Number(expenseId))) {
            params.expenseId = Number(expenseId);
        }
        return await api.get('Expense/payment-summary', { params: params });
    }

    async sendExpensePaymentReminder(paymentTrackingId, actorUserId) {
        return await api.post('Expense/send-reminder', {
            paymentTrackingId: paymentTrackingId,
            actorUserId: actorUserId
        });
    }

    async toggleExpensePaymentAutoPay(paymentTrackingId, isAutoPay, actorUserId) {
        return await api.post('Expense/toggle-autopay', {
            paymentTrackingId: paymentTrackingId,
            isAutoPay: isAutoPay,
            actorUserId: actorUserId
        });
    }

    async payExpenseDueShare(model) {
        return await api.post('Expense/pay-due-share', model);
    }

    async getExpensePaymentDetails(expenseShareId, companyId, userId) {
        return await api.get(`ExpensePayment/${expenseShareId}`, {
            params: {
                companyId: companyId || localStorage.getItem('companyId'),
                userId: userId || localStorage.getItem('userId')
            }
        });
    }

    async getUpcomingRentDue(companyId, userId) {
        return await api.get('ExpensePayment/GetUpcomingRentDue', {
            params: {
                companyId: companyId || localStorage.getItem('companyId'),
                userId: userId || localStorage.getItem('userId')
            }
        });
    }

    async saveExpensePaymentSent(model) {
        return await api.post('ExpensePayment/save-payment-sent', model);
    }

    async saveExpenseVenmoHandler(model) {
        return await api.post('ExpensePayment/save-venmo-handler', model);
    }

    async submitExpensePaymentConfirmation(model) {
        return await api.post('ExpensePayment/ExpensePaymentConfirmation', model);
    }

    async getMeetingRoleContext(userId) {
        return await api.get('Meeting/role-context', { params: { userId: userId } });
    }

    async getMeetings(params) {
        debugger;
        const loginSource = localStorage.getItem('loginSource');

        if (loginSource === 'Mobile') {
            params.pageSize = 1000;
        }
        return await api.get('Meeting/list', { params: params });
    }

    async getMeetingDetails(meetingId, companyId) {
        return await api.get('Meeting/details', {
            params: { meetingId, companyId }
        });
    }

    async getMeetingHodList(masterNames, masterKeyText, userId) {
        return await api.get(`userList/GetMasterItems/${masterNames}/${masterKeyText}/${userId}`);
    }
 
    async getMeetingUserList(masterNames, masterKeyText, userId) {
        return await api.get(`userList/GetMasterItems/${masterNames}/${masterKeyText}/${userId}`);
    }

    async createMeetingRequest(model) {
        return await api.post('Meeting/create-request', model);
    }

    async scheduleMeetingDirect(model) {
        return await api.post('Meeting/schedule', model);
    }

    async approveMeeting(body) {
        return await api.post('Meeting/approve', body);
    }
    getUrlForDynamic() {
        const encryptedEmail = (localStorage.getItem('encryptedEmail') || '').trim();
        //const baseUrl = (CommunicationUcaaS || '').trim().replace(/^['"]|['"]$/g, '');
        //if (!encryptedEmail || !baseUrl) {
        //    return '';
        //}
        //const baseurlFullPath = "https://ucaas.talygen.com/Communication/Index?key=";
        const baseurlFullPath = CommunicationUcaaS;
        return `${baseurlFullPath}${encryptedEmail}`;
    }
    async rejectMeeting(body) {
        return await api.post('Meeting/reject', body);
    }

    async cancelMeeting(body) {
        return await api.post('Meeting/cancel', body);
    }

    async completeMeeting(body) {
        return await api.post('Meeting/complete', body);
    }
    async deleteMeeting(body) {
        return await api.post('Meeting/delete', body);
    }

    /**
     * Validates meeting slot availability (no save).
     * @param {object} payload - see checkMeetingAvailability.js
     */
    async checkMeetingAvailability(payload) {
        return await api.post('Meeting/check-meeting-availability', payload, {
            validateStatus: (status) => [200, 400, 409, 500].includes(status)
        });
    }

    async getVotingProposals(searchFields, sortColumn, sortDir, page, pageSize, userId, companyId) {
        const loginSource = localStorage.getItem('loginSource');

        if (loginSource === 'Mobile') {
            pageSize = 1000;
        }
        const params = {
            searchFields: (typeof searchFields == "undefined" || searchFields == null || searchFields == "") ? "00Test" : searchFields,
            sortColumn: sortColumn,
            sortDir: sortDir,
            page: page,
            pageSize: pageSize,
            userId: userId,
            companyId: companyId
        };
        return await api.get('Voting/get-proposals', { params: params });
    }

    async submitVote(model) {
        return await api.post('Voting/submit-vote', model);
    }
    async DownloadExpenseInvoicePdf(expenseId, userId, status = '', myShare = null) {
        const params = { status: status || '' };
        if (myShare != null && myShare !== '' && !isNaN(Number(myShare))) {
            params.myShare = Number(myShare);
        }
        return await api.get(`Expense/DownloadExpenseInvoicePdf/${expenseId}/${userId}`, {
            params,
            responseType: 'blob'
        });
    }
    async AddExpenseCategory(categorymodel) {
        debugger;
        return await api.post(`ManageVendor/AddExpenseCategory`, categorymodel);
    }
    async expenseCategoryList(search, sortBy, orderBy, pageIndex, pagesize, userId, companyId) {
        debugger;
        return await api.get(`ManageVendor/ExpenseCategoryList/${search}/${sortBy}/${orderBy}/${pageIndex}/${pagesize}/${userId}/${companyId}`);
    }
    async deleteExpenseCategoryById(id) {
        debugger
        return await api.get(`ManageVendor/deleteExpenseCategoryById/${id}`);
    }
    async ReassignScheduleVendor(model) {
        debugger
        return await api.post(`HouseKeeping/ReassignScheduleVendor`, model);
    }
    async ChangeNotificationStatusById(notificationId, isRead) {

        return await api.post("ManageDashBoard/marknotificationreadunread", {
            notificationId: notificationId,
            receiverId: localStorage.getItem("userId"),
            isRead: isRead
        });

    }

    // ---- Household Chore Rotation ----
    async getChoreList(params) {
        return await api.get('Chore/list', { params: params || {} });
    }
    async getChoreDashboard(companyId, assetId, weekStart, weekEnd) {
        const params = { companyId };
        if (assetId) params.assetId = assetId;
        if (weekStart) params.weekStart = weekStart;
        if (weekEnd) params.weekEnd = weekEnd;
        return await api.get('Chore/dashboard', { params });
    }
    async getChoreById(id, companyId) {
        return await api.get(`Chore/${id}`, { params: { companyId } });
    }
    async getChoreDetails(choreId, companyId) {
        return await api.get('Chore/details', { params: { choreId, companyId } });
    }
    async getmyChoresHistory(choreId, companyId) {
        return await api.get('Chore/getChoreHistory', { params: { choreId, companyId } });
    }
    async getChoreHistory(choreId, params) {
        return await api.get(`Chore/history/${choreId}`, { params: params || {} });
    }
    async saveChore(model) {
        return await api.post('Chore/save', model);
    }
    async updateChore(model) {
        return await api.put('Chore/update', model);
    }
    async deleteChore(model) {
        return await api.post('Chore/delete', model);
    }
  async updateStatus(model) {
    return await api.put('Chore/status', model);
  }
    async rotateChore(model) {
        return await api.put('Chore/rotate', model);
    }
    async getMyChores(model) {
        return await api.post('Chore/MyChores', model);
    }
    async updateChoreStatus(model) {
        return await api.post(`Chore/UpdateChoreStatus`,model);
    }
    // ---------- Recurring Expense ----------
    async getRecurringExpenseList(params) {
        const loginSource = localStorage.getItem('loginSource');
        const p = { ...(params || {}) };
        if (loginSource === 'Mobile') {
            p.pageSize = 1000;
        }
        return await api.get('RecurringExpense/list', { params: p });
    }
    async getRecurringExpenseById(id, companyId) {
        return await api.get(`RecurringExpense/${id}`, {
            params: { companyId: companyId || localStorage.getItem('companyId') }
        });
    }
    async addRecurringExpense(model) {
        return await api.post('RecurringExpense/add', model);
    }
    async updateRecurringExpense(model) {
        return await api.put('RecurringExpense/update', model);
    }
    async deleteRecurringExpense(model) {
        return await api.post('RecurringExpense/delete', model);
    }
    async cancelRecurringExpense(model) {
        return await api.post('RecurringExpense/cancel', model);
    }
    async changeRecurringExpenseStatus(model) {
        return await api.put('RecurringExpense/status', model);
    }
    async createExpenseApplePayIntent(model) {
        return await api.post('Expense/create-apple-pay-intent', model);
    }

    async completeExpenseApplePay(model) {
        return await api.post('Expense/complete-apple-pay', model);
    }
    async CreatePaymentIntent(model) {
        return await api.post('Expense/CreatePaymentIntent', model);
    }

    // ---------- Event (Step 1 Create/Edit) ----------
    async getEventById(id, companyId) {
        return await api.get(`Event/${id}`, {
            params: { companyId: companyId || localStorage.getItem('companyId') }
        });
    }
    async getEventBySlug(slug) {
        return await api.get(`Event/by-slug/${encodeURIComponent(slug)}`);
    }
    async addEvent(model) {
        return await api.post('Event/add', model);
    }
    async updateEvent(model) {
        return await api.put('Event/update', model);
    }
    async getEventList(params) {
        return await api.get('Event/list', { params: params || {} });
    }
    async getEventDetail(id, companyId) {
        return await api.get(`Event/${id}/detail`, {
            params: {
                companyId: companyId || localStorage.getItem('companyId'),
                userId: localStorage.getItem('userId')
            }
        });
    }
    async deleteEvent(model) {
        return await api.post('Event/delete', model);
    }
    async cancelEvent(model) {
        return await api.post('Event/cancel', model);
    }
    async reopenEvent(model) {
        return await api.post('Event/reopen', model);
    }
    async getEventGuestList(params) {
        const eventId = params.eventId;
        const p = { ...params };
        delete p.eventId;
        return await api.get(`Event/${eventId}/guest/list`, { params: p });
    }
    async getEventGuestPayDetails(eventId, guestId, companyId) {
        return await api.get(`Event/${eventId}/guest/${guestId}/pay-details`, {
            params: { companyId }
        });
    }
    async addEventGuest(eventId, model) {
        return await api.post(`Event/${eventId}/guest/add`, model);
    }
    async deleteMultipleEventGuests(eventId, model) {
        return await api.post(`Event/${eventId}/guest/delete-multiple`, model);
    }
    async addMultipleEventGuests(eventId, model) {
        return await api.post(`Event/${eventId}/guest/add-multiple`, model);
    }
    async sendEventGuestInvitationEmails(eventId, model) {
        return await api.post(`Event/${eventId}/guest/send-invitation-emails`, model);
    }
    async sendEventGuestInvitationSms(eventId, model) {
        return await api.post(`Event/${eventId}/guest/send-invitation-sms`, model);
    }
    async updateEventGuest(eventId, model) {
        return await api.put(`Event/${eventId}/guest/update`, model);
    }
    async deleteEventGuest(eventId, model) {
        return await api.post(`Event/${eventId}/guest/delete`, model);
    }

    async markEventGuestPaymentPaid(model) {
        return await api.post(`Event/${model.eventId}/guest/mark-paid`, model);
    }
    async markEventGuestPaymentPaid(model) {
        return await api.post(`Event/${model.eventId}/guest/mark-paid`, model);
    }
    async saveGuestGroup(model) {
        return await api.post(`Event/save-guest-group`, model);
    }
    async getEventGuestGroups(
        eventId,
        companyId,
        search = null,
        pageNumber = 1,
        pageSize = 10
    ) {
        return await api.post(`Event/GetEventGuestGroups`, {
            eventId,
            companyId,
            search,
            pageNumber,
            pageSize
        });
    }
    
    async getGuestGroupGuests(model) {
        return await api.post(`Event/GetEventGuestGroupGuests`, model);
    }

    async removeGuestFromGroup(model) {
        return await api.post(`Event/RemoveEventGuestFromGroup`, model);
    }

    /** Reuses ManageContacts contact list (same API as Manage Clients / contact list). */
    async getContactUserList(searchModel) {
        return await api.post(`ManageContacts/GetContactUserList`, searchModel);
    }
    async getPublicEventDetails(slug, encryptedEmail) {
        return await api.get('Event/GetEventDetails', {
            params: {
                slug,
                email: encryptedEmail
            }
        });
    }

    async saveEventPaymentSent(model) {
        return await api.post('Event/SavePaymentSent', model);
    }

    async getFriendInvitationList(model) {
        return await api.post('ManageFriends/GetFriendInvitationList', model);
    }

    async sendFriendInvitation(model) {
        return await api.post('ManageFriends/SendInvitation', model);
    }
    async getFriendDetail(id, companyId) {
        return await api.get(`ManageFriends/GetFriendInvitationById/${id}/${companyId}`);
    }
    async updateFriend(model) {
        return await api.post('ManageFriends/UpdateFriendInvitation', model);
    }
    async deleteFriend(model) {
        return await api.post('ManageFriends/DeleteFriendInvitation', model);
    }
    async getParentList(model) {
        return await api.post('ManageParent/GetParentList', model);
    }
    async addParent(model) {
        return await api.post('ManageParent/AddParent', model);
    }
    async addEventGuestGroupGuest(model) {
        return await api.post(`Event/AddEventGuestGroupGuest`, model);
    }
    async saveGuestGroupBulk(model) {
    return await api.post(`Event/SaveGuestGroupBulk`, model);
}
  async checkMeetingTimeZone(model) {
      return await api.post('Meeting/CheckMeetingTimeZone', model);
    }
    async getguardianTypeOptions(masterNames, masterKeyText, userId) {
        return await api.get(`userList/GetMasterItems/${masterNames}/${masterKeyText}/${userId}`);
    }
    async getEventListeinvite(params) {
        return await api.get('Event/GetEventList', { params });
    }
    // user.service.js
    async savePaymentSent(data) {
        return await api.post('Event/SavePaymentSent', data);
    }
    async saveEventVenmoHandler(model) {
        return await api.post('Event/SaveVenmoHandler', model);
    }
    async addRoommateExpenseParentAssignment(model) {
        return await api.post('ManageParent/AddRoommateExpenseParentAssignment', model);
    }
    async getParentDetail(id, optional, roommateUserId) {
        const config = roommateUserId ? { params: { roommateUserId } } : {};
        return await api.get(`ManageParent/GetUserDetailById/${id}/${optional}`, config);
    }
    async updateParent(model) {
        return await api.post('ManageParent/UpdateParent', model);
    }
    async deleteParent(model) {
        return await api.post('ManageParent/DeleteParent', model);
    }
    async addMasterItem(data) {
        debugger
        return await api.post(`common/addmasteritem`, data);
    }
    async getRoommateExpenseParentAssignment(params) {
        return await api.get('ManageParent/GetRoommateExpenseParentAssignment', { params });
    }
    getVendorServicesList(data) {
        return api.post(
            '/ManageVendor/GetVendorServicesList',
            data
        );
    }
    async getRoommateEventParentAssignment(params) {
        return await api.get('ManageParent/GetRoommateEventParentAssignment', { params });
    }
    async addRoommateEventParentAssignment(model) {
        return await api.post('ManageParent/AddRoommateEventParentAssignment', model);
    }
   
}

export default new UserService();   